import { Empty, Spin } from 'antd'
import Control from 'components/Control/Control'
import AntdInput from 'components/Form/Input'
import AntdSelect from 'components/Form/StudentSelect.js'
import Label from 'components/Label/Label'
import { FormItem, SpinWrapper } from '../../../../../OnBoarding/Register/Education/style'
import { Heading } from './style'
import React, { Fragment, useCallback } from 'react'
import Debounce from '../../../../../../utils/Debounce'

const Address = ({
  form,
  loadingCountry,
  loadingState,
  loadingCity,
  setLoadingCountry,
  setLoadingState,
  setLoadingCity,
  setIsUpdateButtonEnabled,
  countryList,
  stateList,
  cityList,
  onCountryChange,
  onStateChange,
  onCityChange,
  heading,
  address1Name,
  address2Name,
  countryName,
  stateName,
  cityName,
  pincode,
  isTemAddress,
  isSameAddress,
  countryValue,
  stateValue,
  cityValue,
  countryId,
  stateId,
  getStateData,
  getCityData,
  secondAddress1Name,
  secondAddress2Name,
  secondPincode,
  cityId,
  isCorporateMasterExist,
  errorNote,
  setErrorNote,
  getListOfCountries,
  setStateName,
  setStateId,
  setCountryName,
  setCountryId,
  setCityName,
  setCityId,
  handlePinCode,
  frozenFields,
}) => {
  const delayStateToDb = useCallback(
    Debounce((data1, data2, data3) => {
      form.setFieldsValue({
        [stateName]: '',
        [stateName + 'Id']: '',
      })
      setStateName('')
      setStateId('')
      getStateData(data1, data2, data3)
      setErrorNote(prevError => ({
        ...prevError,
        [stateName]: '',
        [cityName]: '',
      }))
    }, 500),
    []
  )

  const delayCitiesToDb = useCallback(
    Debounce((data1, data2, data3, data4) => {
      form.setFieldsValue({
        [cityName]: '',
        [cityName + 'Id']: '',
      })
      setCityId('')
      setCityName('')
      getCityData(data1, data2, data3, data4)
      setErrorNote(prevError => ({
        ...prevError,
        [cityName]: '',
      }))
    }, 500),
    []
  )
  const delayCountryToDb = useCallback(
    Debounce(data => {
      form.setFieldsValue({
        [countryName]: '',
        [countryName + 'Id']: '',
      })
      setCountryName('')
      setCountryId('')
      getListOfCountries(data, false)

      setErrorNote(prevError => ({
        ...prevError,
        [countryName]: '',
        [stateName]: '',
        [cityName]: '',
      }))
    }, 500),
    []
  )

  const handleInputChange = e => {
    setIsUpdateButtonEnabled(false)
  }

  return (
    <Fragment>
      {heading && (
        <Control top="35px">
          <Heading>{heading}</Heading>
        </Control>
      )}
      <Control top="25px" flexStart column>
        <Label>Address line 1 </Label>
        <AntdInput
          placeholder="Enter your address"
          name={address1Name}
          maxLength={120}
          rules={[
            {
              min: 3,
              max: 120,
              message:
                'Please enter address 1! Minimum 3 characters , Maximum 120 characters',
            },
          ]}
          disabled={frozenFields?.[address1Name] || (isTemAddress ? isSameAddress : false)}
          onBlur={e =>
            isSameAddress &&
            form.setFieldValue(secondAddress1Name, e.target.value)
          }
          onChange={handleInputChange}
        />
      </Control>

      <Control top="25px" flexStart column>
        <Label>Address line 2 </Label>
        <AntdInput
          placeholder="Enter your address"
          name={address2Name}
          maxLength={120}
          rules={[
            {
              min: 3,
              max: 120,
              message:
                'Please enter address 2! Minimum 3 characters , Maximum 120 characters',
            },
          ]}
          disabled={frozenFields?.[address2Name] || (isTemAddress ? isSameAddress : false)}
          onBlur={e =>
            isSameAddress &&
            form.setFieldValue(secondAddress2Name, e.target.value)
          }
          onChange={handleInputChange}
        />
      </Control>

      <Control top="25px" flexStart gap="15px">
        <Control flexStart column>
          <Label>Country *</Label>
          <FormItem name={countryName}>
            <div></div>
          </FormItem>
          <AntdSelect
            placeholder="Select"
            name={countryName + 'Id'}
            filterOption={false}
            rules={[
              {
                required: true,
                message: 'Please select country!',
              },
              {
                validator: async (_, value) => {
                  if (value) {
                    let masterList = await isCorporateMasterExist(
                      value,
                      countryName
                    )

                    if (masterList) {
                      return Promise.reject(new Error('Please select country!'))
                    } else {
                      return Promise.resolve()
                    }
                  }
                  return Promise.resolve()
                },
              },
            ]}
            OptionData={loadingCountry ? [] : countryList}
            notFoundContent={
              loadingCountry ? (
                <SpinWrapper center>
                  <Spin />
                </SpinWrapper>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            }
            valueParam="name"
            nameParam="name"
            onChange={onCountryChange}
            value={countryValue}
            showSearch={true}
            disabled={frozenFields?.[countryName] || (isTemAddress ? isSameAddress : false)}
            onSearch={data => {
              setLoadingCountry(true)
              delayCountryToDb(data)
            }}
          />
          {errorNote?.[countryName] && (
            <div style={{ color: '#eb5d60', fontSize: '12px', marginTop: '4px' }}>{errorNote?.[countryName]}</div>
          )}
        </Control>
        <Control flexStart column>
          <Label>State *</Label>
          <FormItem name={stateName}>
            <div></div>
          </FormItem>
          <AntdSelect
            showSearch={true}
            filterOption={false}
            placeholder="Select"
            name={stateName + 'Id'}
            rules={[
              {
                required: true,
                message: 'Please select state!',
              },
              {
                validator: async (_, value) => {
                  if (value) {
                    try {
                      let masterList = await isCorporateMasterExist(
                        value,
                        stateName
                      )

                      if (masterList) {
                        return Promise.reject(new Error('Please select state!'))
                      } else {
                        return Promise.resolve()
                      }
                    } catch (error) {
                      console.error('Error validating state:', error)
                      return Promise.resolve()
                    }
                  }
                  return Promise.resolve()
                },
              },
            ]}
            OptionData={loadingState ? [] : stateList}
            notFoundContent={
              loadingState ? (
                <SpinWrapper center>
                  <Spin />
                </SpinWrapper>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            }
            valueParam="name"
            nameParam="name"
            onChange={onStateChange}
            value={stateValue}
            disabled={
              frozenFields?.[stateName] || (isTemAddress
                ? isSameAddress && form.getFieldValue(countryName)
                  ? true
                  : !form.getFieldValue(countryName)
                : !form.getFieldValue(countryName)
                ? true
                : false)
            }
            onSearch={data => {
              setLoadingState(true)
              delayStateToDb(countryId, !isTemAddress, data)
            }}
          />
          {errorNote?.[stateName] && (
            <div style={{ color: '#eb5d60', fontSize: '12px', marginTop: '4px' }}>{errorNote?.[stateName]}</div>
          )}
        </Control>
      </Control>

      <Control top="25px" flexStart gap="15px">
        <Control flexStart column>
          <Label>City *</Label>
          <FormItem name={cityName}>
            <div></div>
          </FormItem>
          <AntdSelect
            placeholder="Select"
            name={cityName + 'Id'}
            filterOption={false}
            rules={[
              {
                required: true,
                message: 'Please select city!',
              },

              {
                validator: async (_, value) => {
                  if (value) {
                    let masterList = await isCorporateMasterExist(
                      value,
                      cityName
                    )

                    if (masterList) {
                      return Promise.reject(new Error('Please select city!'))
                    } else {
                      return Promise.resolve()
                    }
                  }
                  return Promise.resolve()
                },
              },
            ]}
            OptionData={loadingCity ? [] : cityList}
            notFoundContent={
              loadingCity ? (
                <SpinWrapper center>
                  <Spin />
                </SpinWrapper>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            }
            valueParam="name"
            nameParam="name"
            onChange={onCityChange}
            value={cityValue}
            showSearch={true}
            disabled={
              frozenFields?.[cityName] || (isTemAddress
                ? isSameAddress
                  ? true
                  : !form.getFieldValue(stateName + 'Id') ||
                    !form.getFieldValue(countryName + 'Id')
                : !form.getFieldValue(stateName + 'Id') ||
                  !form.getFieldValue(countryName + 'Id')
                ? true
                : false)
            }
            onSearch={data => {
              setLoadingCity(true)
              delayCitiesToDb(countryId, stateId, !isTemAddress, data)
            }}
          />
          {errorNote?.[cityName] && <div style={{ color: '#eb5d60', fontSize: '12px', marginTop: '4px' }}>{errorNote?.[cityName]}</div>}
        </Control>

        <Control flexStart column>
          <Label>Pincode *</Label>
          <AntdInput
            id={pincode}
            placeholder="121212"
            name={ pincode}
            type={'number'}
            rules={[
              {
                validator: (_, value) => {
                  if (value >= 100000 && value <= 999999) {
                    return Promise.resolve()
                  } else {
                    return Promise.reject(
                      new Error('Please Enter Valid Pincode')
                    )
                  }
                },
              },
            ]}
            disabled={frozenFields?.[pincode] || (isTemAddress ? isSameAddress : false)}
            value={form.getFieldValue(pincode)}
            onChange={e => {
              handlePinCode(e)

              handleInputChange(e)
            }}
          />
        </Control>
      </Control>
    </Fragment>
  )
}

export default Address
